

import { useEffect } from 'react'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useLocation, useNavigate } from 'react-router-dom'
import { useRouteData } from '../../RouteDataContext';
import { getProject } from '../../projectData';
/**
 * SuccessRedemption component
 * Displays a success message and order summary after a successful redemption. Shows order details, total points, and allows navigation back to dashboard.
 */
const SuccessRedemption = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const successData = location.state?.success ?? {}
    const project = getProject()
    const { userData, getUserData } = useRouteData()

    useEffect(() => {
        const sap = userData?.user?.iirpl_sap_code;
        const pkey = project?.pkey;

        if (sap && pkey) {
            getUserData(sap, pkey);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData?.user?.iirpl_sap_code, project?.pkey]);

    const redirectLink = () => {
        navigate('/customer/dashboard')
    }

    return (
        <div className="container py-4 vh-100" style={{ maxWidth: '800px' }}>
            <div className="text-center mb-4">
                <img
                    src={toAbsoluteUrl("/media/images/checked1.png")}
                    alt="Success"
                />
                <h5 className="mt-3 fw-semibold fs-4">Order Placed Successfully</h5>
                <p className="fw-semibold fs-6" style={{ color: "#DC6409" }}>
                    Your Order ID is - {Object.values(successData?.orderDetail ?? {})[0]?.order_id}
                </p>
            </div>

            <div className="card shadow-sm" style={{ borderRadius: '150px' }}>
                <div
                    className="card-header d-flex justify-content-between align-items-center bg-dark text-white p-4"
                    style={{ borderRadius: '15px 15px 0 0', minHeight: "15px" }}
                >
                    <strong>Order Summary</strong>
                    <span>Total Items: <strong>{Object.keys(successData?.orderDetail ?? {}).length}</strong></span>
                </div>

                <div className="card-body p-0 border">
                    <ul className="list-group list-group-flush">
                        {successData && Object.values(successData?.orderDetail)?.map((item, index) => (
                            <li className="list-group-item" key={index}>
                                <div className="d-flex justify-content-between">
                                    <span className="fs-6">{item?.product_name}</span>
                                </div>
                                <div className="d-flex gap-4">
                                    <span className="text-danger fw-semibold fs-6">{item?.total_redeemed} Pts</span>
                                    <div className="fs-6">QTY: {item?.quantity}</div>
                                </div>

                                <span className="fs-6" style={{ color: "#8D5F03" }}>Sub Order ID: </span>
                                {item?.sub_order_id?.join(', ')}
                            </li>
                        ))}
                    </ul>
                </div>
                <div
                    className="card-footer bg-dark text-white d-flex justify-content-between fw-semibold p-4"
                    style={{ borderRadius: '0 0 15px 15px', minHeight: "15px" }}
                >
                    <span>Total Redeem Points</span>
                    <span>{successData?.orderTotal} Points</span>
                </div>
            </div>

            <div className="text-center mt-4">
                <button onClick={redirectLink} className="btn btn-danger w-100 rounded">
                    Ok
                </button>
            </div>
        </div>
    )
}

export default SuccessRedemption